import "highcharts/modules/drilldown";

import { Card, Col, Row, Tag } from "antd"
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useState } from "react";
import { Fragment } from "react/jsx-runtime"
export const BoothSalesperMonthBoothWise = () => {
    const [selectedMonths, setSelectedMonths] = useState<string[]>([]);

    const monthMap: Record<string, string> = {
        Jan: "January",
        Feb: "February",
        Mar: "March",
        Apr: "April",
        May: "May",
        Jun: "June",
        Jul: "July",
        Aug: "August",
        Sept: "September",
        Oct: "October",
        Nov: "November",
        Dec: "December",
    };
    // ✅ Only 12 unique months
    const monthlyData = [
        { month: "Jan", value: 12000 },
        { month: "Feb", value: 15000 },
        { month: "Mar", value: 10000 },
        { month: "Apr", value: 18000 },
        { month: "May", value: 11000 },
        { month: "Jun", value: 9000 },
        { month: "Jul", value: 13000 },
        { month: "Aug", value: 14000 },
        { month: "Sept", value: 8000 },
        { month: "Oct", value: 16000 },
        { month: "Nov", value: 15000 },
        { month: "Dec", value: 17000 },
    ];
    const dailySalesData: Record<string, [string, number][]> = {
        January: [["1 Jan", 4000], ["2 Jan", 4000], ["3 Jan", 4000]],
        February: [["1 Feb", 5000], ["2 Feb", 5000], ["3 Feb", 5000]],
        March: [["1 Mar", 3000], ["2 Mar", 4000], ["3 Mar", 3000]],
        April: [["1 Apr", 6000], ["2 Apr", 6000], ["3 Apr", 6000]],
        May: [["1 May", 4000], ["2 May", 4000], ["3 May", 3000]],
        June: [["1 Jun", 3000], ["2 Jun", 3000], ["3 Jun", 3000]],
        July: [["1 Jul", 5000], ["2 Jul", 4000], ["3 Jul", 4000]],
        August: [["1 Aug", 4000], ["2 Aug", 5000], ["3 Aug", 5000]],
        September: [["1 Sept", 3000], ["2 Sept", 3000], ["3 Sept", 2000]],
        October: [["1 Oct", 5000], ["2 Oct", 6000], ["3 Oct", 5000]],
        November: [["1 Nov", 5000], ["2 Nov", 5000], ["3 Nov", 5000]],
        December: [["1 Dec", 6000], ["2 Dec", 6000], ["3 Dec", 5000]],
    };
    const handleMonthToggle = (month: string) => {
        setSelectedMonths((prev) =>
            prev.includes(month) ? prev.filter((m) => m !== month) : [...prev, month]
        );
    };

    const drilldownSeries = Object.entries(dailySalesData).map(([month, data]) => ({
        id: month,
        name: `Daily Sales - ${month}`,
        data,
        type: "column",
        color: "#fadb14",
    }));
    const baseSeriesData =
        selectedMonths.length === 0
            ? monthlyData.map((m) => ({
                name: m.month,
                y: m.value,
                drilldown: monthMap[m.month],
            }))
            : selectedMonths.map((month) => {
                const fullMonth = monthMap[month];
                const total =
                    dailySalesData[fullMonth]?.reduce((sum, [, value]) => sum + value, 0) || 0;
                
return { name: month, y: total };
            });

    const chartOptions: Highcharts.Options = {
        chart: {
            type: "column",
        },
        title: {
            text:
                selectedMonths.length === 0
                    ? "Booth Sales per Month"
                    : `Combined Sales for: ${selectedMonths.join(", ")}`,
        },
        xAxis: {
            type: "category",
        },
        yAxis: {
            title: {
                text: "Sales (KWD)",
            },
        },
        legend: {
            enabled: false,
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: "{point.y:.0f} KWD",
                },
            },
        },
        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}</b> KWD<br/>',
        },
        series: [
            {
                name:
                    selectedMonths.length === 0
                        ? "Monthly Sales"
                        : `Total Sales (${selectedMonths.length} month${selectedMonths.length > 1 ? "s" : ""
                        })`,
                type: "column",
                color: "#fadb14",
                colorByPoint: true,
                 data: baseSeriesData.map((point) => ({
                    ...point,
                    color: "#fce647", // Apply yellow
                })),
            },
        ],
        drilldown: selectedMonths.length === 0 ? { series: drilldownSeries } : undefined as any,
    };
    
return (
        <Fragment>
            <Card>
                <Row gutter={[16, 16]} className="month_tabs">
                    {monthlyData.map((month) => (
                        <Col key={month.month}>
                            <Tag
                                color={selectedMonths.includes(month.month) ? "yellow" : "default"}
                                style={{ cursor: "pointer" }}
                                onClick={() => handleMonthToggle(month.month)}
                            >
                                {month.month}
                            </Tag>
                        </Col>
                    ))}
                </Row>
                <HighchartsReact highcharts={Highcharts} options={chartOptions} />
            </Card>
        </Fragment>
    )
}